import { render, staticRenderFns } from "./EditVendorPage.vue?vue&type=template&id=64db5e33&scoped=true&"
import script from "./EditVendorPage.vue?vue&type=script&lang=js&"
export * from "./EditVendorPage.vue?vue&type=script&lang=js&"
import style0 from "./EditVendorPage.vue?vue&type=style&index=0&id=64db5e33&prod&lang=scss&scoped=true&"
import style1 from "./EditVendorPage.vue?vue&type=style&index=1&id=64db5e33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db5e33",
  null
  
)

export default component.exports